import { FetchBaseQueryError, createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';

import type { QueryReturnValue } from '@reduxjs/toolkit/dist/query/baseQueryTypes';
import { Order } from '../../services/exports/Interfaces';
import OrderManager from '../../services/api/OrderManager';
import { OrderFulfillmentScope } from '../../services/exports/Constants';

interface GetOrdersHistoryDto {
  status?: OrderFulfillmentScope;
  params?: { limit: number };
  companyId?: number;
}

export enum OrdersApiSliceTags {
  Order = 'Order',
}

export const ordersApiSlice = createApi({
  baseQuery: fakeBaseQuery(),
  reducerPath: 'ordersApiSlice',
  tagTypes: [OrdersApiSliceTags.Order],
  endpoints: (build) => ({
    getOrderHistory: build.query<QueryReturnValue<Order[], FetchBaseQueryError>, GetOrdersHistoryDto>({
      queryFn: ({ params, status, companyId }) =>
        OrderManager.getOrderHistory(params, status, companyId).then((res) => {
          if (res.success) {
            return { data: res.response.data, status: res.status };
          }

          return {
            error: {
              data: res.response,
              status: res.status,
            },
          };
        }),
      providesTags: [OrdersApiSliceTags.Order],
    }),
    getOrder: build.query<QueryReturnValue<Order, FetchBaseQueryError>, string>({
      queryFn: (uuid) =>
        OrderManager.getOrder(uuid).then((res) => {
          if (res.success) {
            return { data: res.response.data, status: res.status };
          }

          return {
            error: {
              data: res.response,
              status: res.status,
            },
          };
        }),
      providesTags: [OrdersApiSliceTags.Order],
    }),
  }),
});

export const { useGetOrderHistoryQuery, useGetOrderQuery } = ordersApiSlice;
